import React from "react";
import styles from "./TopicDates.module.sass";
import cn from "classnames";
import Card from "../../../../../components/Card";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const TopicDates = ({
                      className,
                      startDate,
                      setStartDate,
                      endDate,
                      setEndDate
                    }) => {

  const formatDateRange = () => {
    const start = startDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short'
    });
    const end = endDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short'
    });
    return `${start} - ${end}`;
  };

  return (
      <Card className={cn(styles.card, className)} >
        <div className={styles.list}>
          <div className={styles.item}>

            {/* Date Range Display */}
            <div className={styles.dateDisplay}>
              {formatDateRange()}
            </div>

            {/* Date Input Fields */}
            <div className={styles.dateInputsContainer}>
              <div className={styles.dateInputs}>
                <div className={styles.dateField}>
                  <div className={styles.label}>
                    🚀 Start Date
                  </div>
                  <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className={styles.datePicker}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select start date"
                      showPopperArrow={false}
                  />

                </div>

                <div className={styles.dateField}>
                  <div className={styles.label}>
                    🏁 End Date
                  </div>
                  <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      className={styles.datePicker}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select end date"
                      minDate={startDate}
                      showPopperArrow={false}
                  />

                </div>
              </div>

              {/* Duration Info */}
              <div style={{
                marginTop: '16px',
                padding: '12px',
                background: 'transparent',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                textAlign: 'center'
              }}>
              <span style={{
                fontSize: '13px',
                color: '#6c757d',
                fontWeight: '500'
              }}>
                Duration: {Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))} days
              </span>
              </div>
            </div>
          </div>
        </div>
      </Card>
  );
};

export default TopicDates;
